import { AwbPartStatuses } from "../models/AwbPart";

const AWB_PART_STATUSES_SCHEMA: AwbPartStatuses = {
  import: [],
  export: []
};

export { AWB_PART_STATUSES_SCHEMA };